import {
  useGetRespondentLinkReissue,
  type RespondentsLinkReissueStatus,
} from "@wellcheck/api-client";

/**
 * useLinkReissueStatus — 回答リンク再発行の対象確認 (GET /api/respondent-link-reissue, ADR-0061
 * Decided Questions #8 改訂: status は eligible/throttled/closed/ineligible の 4 状態)。
 *
 * InvalidLinkScreen (無効リンク画面) が表示されている間だけ呼ぶ想定 (session.status==="invalid" の
 * ときのみ campaignId/respondentId が確定するため)。5xx 等の予期しない失敗も ineligible と
 * 同様にボタンを出さない側に倒すため、useRespondSession (retry: false) と同じく retry しない。
 */
export interface UseLinkReissueStatusParams {
  campaignId: string;
  respondentId: string;
}

export interface UseLinkReissueStatusResult {
  isLoading: boolean;
  data: RespondentsLinkReissueStatus | undefined;
}

export function useLinkReissueStatus({
  campaignId,
  respondentId,
}: UseLinkReissueStatusParams): UseLinkReissueStatusResult {
  const query = useGetRespondentLinkReissue(
    { campaignRecordId: campaignId, respondentRecordId: respondentId },
    {
      query: {
        retry: false,
        refetchOnWindowFocus: false,
        select: (response): RespondentsLinkReissueStatus | undefined =>
          response.status === 200 ? response.data : undefined,
      },
    },
  );

  return { isLoading: query.isLoading, data: query.data };
}
